import { UserLocation } from './locations';
import { getCachedLocation, getUserLocation } from './geolocation';

// Get user location from cache or detect
export const getCurrentUserLocation = async (): Promise<UserLocation | null> => {
  // Try cache first
  const cached = getCachedLocation();
  if (cached) return cached;
  // Otherwise, detect
  return await getUserLocation(false);
};
